import { Link } from "react-router-dom";
import FAQsLayout from "./layouts/FAQs";

function FAQs() {

    return (
        <>
            <div className="container-xxl py-5 bg-dark page-header mb-5">
                <div className="container my-5 pt-5 pb-4">
                    <h1 className="display-3 text-white mb-3 animated slideInDown">Frequently Asked Questions</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb text-uppercase">
                            <li className="breadcrumb-item">
                                <Link to="/">Home</Link>
                            </li>
                            
                            <li className="breadcrumb-item active" aria-current="page">
                                <Link to="/faqs" className="text-white">Frequently Asked Questions</Link>
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>

            <div className="container-xxl py-5">
                <div className="container">
                    <div className="wow fadeInUp" data-wow-delay="0.5s">
                        <FAQsLayout />
                    </div>
                </div>
            </div>
        </>
    );
}

export default FAQs;